import script from "./ContentPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ContentPreview.vue?vue&type=style&index=0&id=a1cc96ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1cc96ea"]])

export default __exports__